import useActivePosition from 'hooks/models/position/useActivePosition';
import { useFeatureFlags } from 'utils/features';
import { canTimeEventsForAnyone } from 'utils/positionUtils';

export default function useTimeLogFeedEnabled() {
  const toggle = useFeatureFlags('TIME_LOG_FEED');
  const ldToggle = useFeatureFlags('TIME_ENTRY_HISTORY_LOG_FEED');
  const activePosition = useActivePosition();
  return toggle && ldToggle && canTimeEventsForAnyone(activePosition);
}
